import React, {
  FC,
} from 'react';
import { FaqTitle, FaqEnTitle, FaqContent, FaqEnContent, SplitLine, Column } from './Styles';

const ZH: FC = () => {
  return (
    <>
      {/* 中文条款 */}
      <div style={{ width: '90%', overflow: 'auto', marginLeft: 'auto', marginRight: 'auto', textAlign: 'left' }}>
        <FaqTitle>
          赚取 <FaqEnTitle>Foodifox</FaqEnTitle> 积分
        </FaqTitle>
        <FaqContent>
          现在有更多赚取积分的方法：
        </FaqContent>
        <FaqContent>
          1. 成功通过送餐柜送餐并上传送餐照片赚取奖励积分。
          <br />
          2. 奖励积分 - 通过参加促销活动或推荐朋友赚取奖励积分。
        </FaqContent>
        <FaqContent>
          如果您使用了送餐柜但未完成订单，则可能会从您的帐户中扣除积分。
          <br />
          <FaqEnContent>Foodifox</FaqEnContent> 保留修改奖励计划任何细节的权利。
        </FaqContent>
        <FaqContent>
          注意：<FaqEnContent>Foodifox Drop-Off</FaqEnContent> 积分与 <FaqEnContent>Foodifox Cafe</FaqEnContent> 积分不同。<FaqEnContent>Foodifox Drop-Off</FaqEnContent> 积分将在 1 年后于获得积分的同月月底到期。 这适用于所有积分。 （例如，2023 年 11 月在 <FaqEnContent>Foodifox</FaqEnContent> 账户中获得的积分将于 2024 年 11 月 30 日到期。）
        </FaqContent>

        {/* 分割线 */}
        <Column>
          <SplitLine />
        </Column>

        <FaqTitle>
          使用<FaqEnTitle>Foodifox</FaqEnTitle>积分
        </FaqTitle>
        <FaqContent>
          您的积分余额显示在 <FaqEnContent>Foodifox Drop-Off APP</FaqEnContent>内的仪表板和兑换页面上。 这是可供您通过<FaqEnContent>Foodifox Drop-Off APP</FaqEnContent>兑换的余额。
          您可以使用积分通过 <FaqEnContent>Foodifox Drop-Off APP</FaqEnContent>兑换奖励。 请按照兑换页面上每个奖励选项的说明进行操作。
        </FaqContent>

        {/* 分割线 */}
        <Column>
          <SplitLine />
        </Column>

        <FaqTitle>
          查看 <FaqEnTitle>Foodifox</FaqEnTitle> 积分
        </FaqTitle>
        <FaqContent>
          请登录您的 <FaqEnContent>Foodifox</FaqEnContent> 帐户并在仪表板或兑换页面上查看余额。
        </FaqContent>

        {/* 分割线 */}
        <Column>
          <SplitLine />
        </Column>

        <FaqTitle>
          <FaqEnTitle>Foodifox</FaqEnTitle> 积分的有效期
        </FaqTitle>
        <FaqContent>
          获得的 <FaqEnContent>Foodifox</FaqEnContent> 积分将在 1 年有效期内于获得积分的当月月底到期。 （例如，2023 年 11 月获得的积分将于 2024 年 11 月 30 日到期）
        </FaqContent>

        {/* 分割线 */}
        <Column>
          <SplitLine />
        </Column>

        <FaqTitle>
          退还 <FaqEnTitle>Foodifox</FaqEnTitle> 积分
        </FaqTitle>
        <FaqContent>
          一旦您成功兑换奖励，积分将立即扣除，此时无法退款。
        </FaqContent>
      </div>
    </>
  );
};

export default ZH;
